export default __webpack_public_path__ + "static/media/img--design-10.252da017.jpg";